import { Payload, useFetchMutation } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';
import { toObjectified } from 'api/baseApi';

const purchaseOrderLineDetailsResponseParser = (response) => {
    const { Customer } = response;

    return {
        ...response,
        CustomerDetails: Customer ? toObjectified(Customer) : null,
    };
};

export const useRetrieveCustomerDetails = () =>
    useFetchMutation<Payload<{ CustomerId?: number }>, any>
        (
            APIRoutes.customer.detail.retrieve, null,
            {
                inline: true,
                responseParser: purchaseOrderLineDetailsResponseParser
            }
        );
